import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import Item from './Item';
import ScrollButton from './ScrollButton';
import {
  ArrowBackIosRounded as BackIcon,
  ArrowForwardIosRounded as ForwardIcon
} from '@material-ui/icons';


const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative'
  },
  scroll: {
    display: 'flex',
    overflowX: 'scroll'
  }
}));


/**
 * Horizontal image selector.
 * @param {images, handleSelect} props
 */
function Horizontal(props) {
  const { images, handleSelect, scrollEnd } = props;
  const classes = useStyles();
  const scrollRef = useRef(null);


  useEffect(() => {
    const scroll = (event) => {
      event.preventDefault();
      scrollRef.current.scrollTo({
        left: scrollRef.current.scrollLeft + event.deltaY
      });
  
      const cur = scrollRef.current;
      if ((cur.scrollWidth - cur.clientWidth - cur.scrollLeft) < cur.clientWidth) {
        scrollEnd();
      }
    }

    scrollRef.current.addEventListener('mousewheel', scroll);
  }, [scrollEnd]);


  var prevDate = null;
  const showDate = (image) => {
    let day = format(parseISO(image.capturedAt), 'yyyy-MM-dd');
    if (prevDate === null || prevDate !== day) {
      prevDate = day;
      return true;
    }
    return false;
  }

  const scrollBy = (dx) => {
    const cur = scrollRef.current;

    if ((cur.scrollWidth - cur.clientWidth - cur.scrollLeft - dx) < cur.clientWidth) {
      scrollEnd();
    }

    cur.scrollTo({
      top: 0,
      left: scrollRef.current.scrollLeft + dx,
      behavior: 'smooth'
    });
  }

  const scrollLeft = () => scrollBy(-scrollRef.current.clientWidth * 0.8);

  const scrollRight = () => scrollBy(scrollRef.current.clientWidth * 0.8);


  return (
    <div className={classes.root}>
      <ScrollButton
        icon={<BackIcon />}
        end='left'
        onClick={scrollLeft}
      />
      <ScrollButton
        icon={<ForwardIcon />}
        end='right'
        onClick={scrollRight}
      />

      <div
        className={classes.scroll}
        ref={scrollRef}
      >
        {images.map((image, idx) => (
          <Item
            key={image.id}
            image={image}
            showDate={showDate(image)}
            orientation='h'
            handleSelect={() => handleSelect(idx)}
          />
        ))}
      </div>
    </div>
  )
}

export default Horizontal;
